import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { AddCommitmentNotesResult } from './add-commitment-notes.action';

export function addCommitmentNotesResultReducer(
    state: TranscriptDialogState,
    action: PayloadAction<ActionType, AddCommitmentNotesResult>,
): TranscriptDialogState {
    const navigateCmtId =
        action.payload.commitmentInfo.find((e) => e.commitmentId)
            ?.commitmentId ?? null;
    const navigateDraftId =
        action.payload.commitmentInfo.find((e) => e.draftId)?.draftId ?? null;

    return {
        ...state,
        navigateCmtId,
        navigateDraftId,
        willNavigate: action.payload.willNavigate,
    };
}
